import { getComponentClasses } from '@99designs/frontend-components/utils/app';
import React from 'react';

export function getSpacingClass(verticalSpacing: Size) {
    return getComponentClasses('vertical-spacing', [verticalSpacing]);
}

export type Type = 'span' | 'div' | 'section';

export type Size =
    | 'none'
    | 'text'
    | 'quarterGutter'
    | 'halfGutter'
    | 'gutter'
    | 'doubleGutter'
    | 'oneAndHalfGutter'
    | 'tripleGutter'
    | 'space2'
    | 'space3'
    | 'space4'
    | 'space5'
    | 'space6'
    | 'space7'
    | 'space8'
    | 'space9'
    | 'space10'
    | 'space11'
    | 'space12'
    | 'space13'
    | 'space14'
    | 'space15'
    | 'space16';

// FIXME: use once const assertions are fixed
// export type Size = typeof spaces[number];

export interface VerticalSpacingProps extends React.HTMLAttributes<HTMLElement> {
    verticalSpacing?: Size;
    type?: Type;
    id?: string;
    children?: React.ReactNode;
}

export default function VerticalSpacing({
    children,
    verticalSpacing = 'none',
    type = 'span',
}: VerticalSpacingProps) {
    const Component = type;

    return <Component className={getSpacingClass(verticalSpacing)}>{children}</Component>;
}

export function FullWidthPageSection({ children, verticalSpacing = 'none' }: VerticalSpacingProps) {
    return (
        <VerticalSpacing type="section" verticalSpacing={verticalSpacing}>
            {children}
        </VerticalSpacing>
    );
}

export function GridPageSection({ children, verticalSpacing = 'none' }: VerticalSpacingProps) {
    return (
        <FullWidthPageSection verticalSpacing={verticalSpacing}>
            <div className="row">
                <div className="column">{children}</div>
            </div>
        </FullWidthPageSection>
    );
}
